<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-masterColor',
  components: { PageTable },
}
</script>
